<template>
    <BasePanel
        headline="lang_GENERIC_CAPTION_CONTRIBUTORS"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="listItems"
                :items-per-page="1000"
                hide-default-footer
                :header-props="{ sortIcon: '' }"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
            >
            <!-- TOP SLOT -->
                <template v-slot:top>
                    <v-row class="pb-3">
                        <v-spacer></v-spacer>
                        <v-col cols="3">
                            <BaseButton 
                                @click="addNewRow"
                                :disabled="$route.params.alvId === 'new'"
                                label="lang_GENERAL_BUTTON_ADD_ROW"
                                block
                                :alvqa="alvqa + '-button-add-row'"
                            />
                        </v-col>
                    </v-row>
                </template>

            <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

            <!-- Items -->
                <template v-slot:[`item.artist`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-artist'">
                        {{ $alvPlugin.getArtistOrPerformerName(item.artist) }}
                    </div>
                </template>
                <template v-slot:[`item.role`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-role'">
                        {{ getRole(item.role) }}
                    </div>
                </template>
                <template v-slot:[`item.primary`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-primary'">
                        {{ getYesOrNo(item.primary) }}
                    </div>
                </template>

            <!-- Buttons -->
                <template v-slot:[`item.delete`]="{ item }">
                    <BaseIcon 
                        @click="deleteRow(item)"
                        icon="delete"
                        color="iconDelete"
                        tooltipText="lang_GENERIC_CAPTION_DELETE"
                        :alvqa="alvqa + 'list-row-icon-delete'"
                    />
                </template>
                <template v-slot:[`item.inlineEdit`]="{ item }">
                    <BaseIcon   
                        :alvqa="alvqa + '-list-row-icon-inline-edit'"
                        icon="edit" 
                        tooltipText="lang_GENERAL_CAPTION_ICON_EDIT"   
                        @click.stop="editInlineFunction(item)"
                    />
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseIcon from '@/components/_buttons/BaseIcon'

import { 
    DropdownGeneralArtistRoles,
    DropdownGenericYesNo
} from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "TracksArtistsEditPanel",
    components: {
        BasePanel,
        BaseButton,
        BaseIcon
    },
    data() {
        return {
            alvqa: 'label-tracks-edit-form-panel-artists'
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t("lang_LABEL_TRACKS_CAPTION_NAME"), 
                    align: "left", 
                    value: "artist",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-artist'
                },
                {
                    text: this.$t("lang_LABEL_TRACKS_CAPTION_ROLE"), 
                    align: "left", 
                    value: "role",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-role'
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_CHECKBOX_PRIMARY_ARTIST"), 
                    align: "left", 
                    value: "primary",
                    class: 'text-no-wrap',
                    width: "100px",
                    sortable: false,
                    alvqa: this.alvqa + '-header-primary'
                },
                {
                    text: '', 
                    value: 'inlineEdit',
                    align: 'right',
                    sortable: false,
                    width: "70px",
                    class: 'text-no-wrap'
                },
                {
                    text: "",
                    align: "right",
                    width: "70px",
                    value: "delete",
                    sortable: false,
                    class: 'text-no-wrap'
                }
            ]
        },

        listItems() { return this.$store.getters.getTracksArtists }
    },
    methods: {
        addNewRow() {
            this.$store.commit('setTracksArtistsArtistOptions', [])
            this.$store.commit('setTracksArtistsDetailsPrimary', 'no')
            this.$store.commit('setShowTracksArtistsEditingDialog', true)
            this.$store.commit('setEditingDialogHeadline', this.$t('lang_GENERAL_CAPTION_NEW_ENTRY'))

            let defaultValues = JSON.parse(JSON.stringify(this.$store.getters.getDefaultTracksArtists)) 
            this.$store.commit('setTracksArtistsEditingDialogDetails', defaultValues)
        },

        deleteRow(item) {
            // set the selected row that should be deleted from the delete action 
            // and open the deletion dialog
            this.$store.commit("setSelectedTracksArtists", item)
            this.$store.commit('setDeletionDialogContext', 'SelectedTracksArtists')
            this.$store.commit('setShowDeletionDialog', true)
        },

        editInlineFunction(item) {
            this.$store.commit('setSelectedTracksArtists', item.id)
            let detailsDeepCopy = JSON.parse(JSON.stringify(item))

            // set the copy in dialog details to edit
            this.$store.commit('setTracksArtistsEditingDialogDetails', detailsDeepCopy)
            this.$store.commit('setTracksArtistsArtistOptions', [item.artist])
            this.$store.commit('setEditingDialogHeadline', this.$t("lang_GENERAL_CAPTION_EDITING_ENTRY")) // set headline
            this.$store.commit('setShowTracksArtistsEditingDialog', true) 
        },

        getRole(roleValue) {
            let roles = DropdownGeneralArtistRoles

            if(roles !== undefined) {
                return roles.find(role => {
                    return role.value === roleValue
                }).text
            }
        },
        getYesOrNo(value) {
            if(value == null) value = "no"
            let match = DropdownGenericYesNo.find(element => {
                return element.value === value
            }).text

            return this.$t(match)
        }
    }
}
</script>


<style>
    .noMinWidth table {
        min-width: 0px !important;
        table-layout: fixed;
    }
</style>